import { batchInfo } from "@/lib/apiClient/client.ts"
import { BaseDiffViewModel } from "@/routes/tasks/TaskViewScene/BaseDiffViewModel.ts"

import type { GitCommitChange, TID } from "@/lib/client/generated/TypeDefinitions.ts"
import type { GlobalContext } from "@/lib/context.ts"
import type { Queries } from "@/lib/queries.ts"
import type { TaskViewModel } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"


export class TaskChangesFromPreviousVersionModel extends BaseDiffViewModel {
  constructor(
    protected readonly model: TaskViewModel,
    protected readonly context: GlobalContext,
    protected readonly queries: Queries,
  ) {
    super("TaskChangesFromPreviousVersionModel")
  }

  downloadPatch(): void {
    // TODO: partial patch download
    this.queries.apiClient.downloadPatch(this.model.taskId as TID)
  }

  protected async fetchChanges(): Promise<GitCommitChange[]> {
    const task = this.model.task.get()
    if (!task) throw new Error("Task is not ready")

    const historyItems = this.model.historyItems.get()
    if (historyItems.length < 1) return []

    const activeItems = historyItems.filter(item => item.isActive)
    if (activeItems.length < 1) return []

    const latestCommit = activeItems[activeItems.length - 1].commit.id

    return await this.queries.getCommitChanges(batchInfo(100), this.model.project.get().key, this.model.repositoryName, [latestCommit])
  }
}
